<template>
  <a-drawer
    :title="drawerTitle"
    placement="right"
    width="85%"
    :visible="visible"
    :destroy-on-close="true"
    @close="handleClose"
  >
    <a-spin :spinning="loading">
      <a-descriptions v-if="detail" bordered :column="2" size="small">
<!--        <a-descriptions-item :label="$t('views.goodsOrder.column.id')">{{ cell(detail.id) }}</a-descriptions-item>-->
        <a-descriptions-item :label="$t('views.goodsOrder.detail.userId')">{{ cell(detail.userId) }}</a-descriptions-item>
<!--        <a-descriptions-item :label="$t('views.goodsOrder.detail.goodsId')">{{ cell(detail.goodsId) }}</a-descriptions-item>-->
        <a-descriptions-item :label="$t('views.goodsOrder.column.email')">{{ cell(detail.email) }}</a-descriptions-item>
        <a-descriptions-item :label="$t('views.goodsOrder.column.nickname')">{{ cell(detail.nickname) }}</a-descriptions-item>
<!--        <a-descriptions-item :label="$t('views.goodsOrder.column.goodsName')">{{ cell(detail.goodsName) }}</a-descriptions-item>-->
        <a-descriptions-item :label="$t('views.goodsOrder.column.orderType')">{{ formatOrderType(detail.orderType) }}</a-descriptions-item>
        <a-descriptions-item :label="$t('views.goodsOrder.column.orderStatus')">{{ formatOrderStatus(detail.orderStatus) }}</a-descriptions-item>
        <a-descriptions-item :label="$t('views.goodsOrder.column.productionStatus')">{{ formatProductionStage(detail.productionStatus) }}</a-descriptions-item>
        <a-descriptions-item :label="$t('views.goodsOrder.column.orderNo')">
          <span class="goods-order-detail-copy-line">
            <span class="goods-order-detail-copy-text">{{ cell(detail.orderNo) }}</span>
            <a-button
              v-if="hasCopyableText(detail.orderNo)"
              type="link"
              size="small"
              class="goods-order-detail-copy-btn"
              @click="copyField(detail.orderNo)"
            >{{ $t('views.goodsOrder.detail.copy') }}</a-button>
          </span>
        </a-descriptions-item>
<!--        <a-descriptions-item :label="$t('views.goodsOrder.detail.firstStatus')">{{ formatSubPayment(detail.firstStatus) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.detail.finalStatus')">{{ formatSubPayment(detail.finalStatus) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.detail.productionStatus')">{{ formatBool01(detail.productionStatus) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.column.width')">{{ cell(detail.width) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.column.height')">{{ cell(detail.height) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.column.bottom')">{{ cell(detail.bottom) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.column.thickness')">{{ cell(detail.thickness) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.weight')">{{ cell(detail.weight) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.exchangeRate')">{{ cell(detail.exchangeRate) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.shippingMethod')">{{ cell(detail.shippingMethod) }}</a-descriptions-item>-->
        <a-descriptions-item :label="$t('views.goodsOrder.column.stylesNum')">{{ cell(detail.stylesNum) }}</a-descriptions-item>
        <a-descriptions-item :label="$t('views.goodsOrder.column.totalNum')">{{ cell(detail.totalNum) }}</a-descriptions-item>
<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.payMoney')">{{ cell(detail.payMoney) }}</a-descriptions-item>-->

<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.paidMoney')">{{ cell(detail.paidMoney) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.shippingMoney')">{{ cell(detail.shippingMoney) }}</a-descriptions-item>-->
<!--        <a-descriptions-item :label="$t('views.goodsOrder.search.goodMoney')">{{ cell(detail.goodMoney) }}</a-descriptions-item>-->
        <a-descriptions-item :label="$t('views.goodsOrder.search.printingMeters')">{{ cell(detail.printingMeters) }}</a-descriptions-item>
        <a-descriptions-item :label="$t('views.goodsOrder.column.createTime')">{{ detail.createTime ? parseTime(detail.createTime) : cell(null) }}</a-descriptions-item>
      </a-descriptions>
      <div v-if="detail && isOrderProducing" class="goods-order-remark-plain goods-order-production-steps-wrap">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.productionProgress') }}</div>
        <div class="goods-order-production-steps-scroll">
          <a-steps :current="productionStepCurrent" size="small">
            <a-step
              v-for="stepNum in 8"
              :key="stepNum"
              :title="$t('views.goodsOrder.productionStage.' + stepNum)"
            />
          </a-steps>
        </div>
      </div>
      <div v-if="detail && isOrderShipped" class="goods-order-remark-plain">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.deliveryInfo') }}</div>
        <a-descriptions bordered :column="2" size="small">
          <a-descriptions-item :label="$t('views.goodsOrder.orderBox.deliveryNumber')">
            <span class="goods-order-detail-copy-line">
              <span class="goods-order-detail-copy-text">{{ cell(detail.deliveryNumber) }}</span>
              <a-button
                v-if="hasCopyableText(detail.deliveryNumber)"
                type="link"
                size="small"
                class="goods-order-detail-copy-btn"
                @click="copyField(detail.deliveryNumber)"
              >{{ $t('views.goodsOrder.detail.copy') }}</a-button>
            </span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.orderBox.deliveryTime')">{{ detail.deliveryTime ? parseTime(detail.deliveryTime) : cell(null) }}</a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-if="detail && detail.orderAddress" class="goods-order-remark-plain">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.shippingAddress') }}</div>
        <a-descriptions bordered :column="2" size="small">
          <a-descriptions-item :label="$t('views.goodsOrder.detail.receiverName')">{{ cell(detail.orderAddress.reciverName) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.detail.receiverPhone')">{{ cell(detail.orderAddress.reciverTelephone) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.detail.addressLabel')">{{ cell(detail.orderAddress.addressLabel) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.detail.detailedAddress')">{{ cell(detail.orderAddress.detailedAddress) }}</a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-if="detail && jsonData.length" class="goods-order-remark-plain">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.productDetail') }}</div>
        <a-descriptions bordered :column="2" size="small">
          <a-descriptions-item
            v-for="(item, index) in jsonData"
            :key="index"
            :label="splitProductLine(item).label"
          >{{ splitProductLine(item).value }}</a-descriptions-item>
        </a-descriptions>
      </div>

      <div v-if="detail" class="goods-order-remark-plain">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.quoteDetail') }}</div>
        <a-descriptions bordered :column="2" size="small">
          <a-descriptions-item :label="$t('views.goodsOrder.detail.styleCount')">{{ cell(detail.stylesNum) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.detail.priceTierTotalQty')">{{ cell(detail.totalNum) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.column.payMoney')">{{ cell(detail.goodMoney) }}</a-descriptions-item>
          <a-descriptions-item v-if="detail.exchangeRate" :label="$t('views.goodsOrder.detail.exchangeRateLabel')">{{ cell(detail.exchangeRate) }}</a-descriptions-item>
          <a-descriptions-item v-if="detail.weight" :label="$t('views.goodsOrder.detail.weightLabel')">{{ cell(detail.weight) }}</a-descriptions-item>
          <a-descriptions-item v-if="detail.shippingMethod" :label="$t('views.goodsOrder.detail.shippingMethodLabel')">{{ cell(detail.shippingMethod) }}</a-descriptions-item>
          <a-descriptions-item v-if="detail.shippingMoney > 0" :label="$t('views.goodsOrder.detail.shippingFee')">{{ cell(detail.shippingMoney) }}</a-descriptions-item>
        </a-descriptions>
      </div>

      <div v-if="detail" class="goods-order-remark-plain">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.priceInfo') }}</div>
        <a-descriptions bordered :column="2" size="small">
          <a-descriptions-item :label="$t('views.goodsOrder.detail.paymentMethod')">{{ formatOrderTypeString(detail.orderType) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('views.goodsOrder.detail.orderAmount')">{{ cell(detail.payMoney) }}</a-descriptions-item>
          <a-descriptions-item
            v-if="isFirstPaymentOrderType"
            :label="$t('views.goodsOrder.search.firstMoney')"
          >{{ cell(detail.firstMoney) }}</a-descriptions-item>
          <a-descriptions-item
            v-if="isFirstPaymentOrderType"
            :label="$t('views.goodsOrder.search.finalMoney')"
          >{{ cell(detail.finalMoney) }}</a-descriptions-item>
        </a-descriptions>
      </div>


      <div v-if="detail && priceTierList.length" class="goods-order-price-tier goods-order-price-tier-standalone">
        <div class="goods-order-price-tier-title">{{ $t('views.goodsOrder.detail.priceTierTitle') }}</div>
        <div class="goods-order-price-tier-scroll">
          <table class="goods-order-price-tier-table">
            <tbody>
              <tr>
                <th class="goods-order-price-tier-row-head">{{ $t('views.goodsOrder.detail.priceTierTotalQty') }}</th>
                <td v-for="(item, idx) in priceTierList" :key="'tn-' + idx">{{ formatTierTotalNum(item.totalNum) }}</td>
              </tr>
              <tr>
                <th class="goods-order-price-tier-row-head">{{ $t('views.goodsOrder.detail.priceTierPrice') }}</th>
                <td v-for="(item, idx) in priceTierList" :key="'m-' + idx">{{ formatTierMoney(item.money) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else-if="detail && plainRemarkDisplay" class="goods-order-remark-plain">
        <div class="goods-order-remark-plain-label">{{ $t('views.goodsOrder.detail.remark') }}</div>
        <div class="goods-order-detail-remark">{{ plainRemarkDisplay }}</div>
      </div>


      <a-empty v-if="!detail && !loading" :description="$t('views.goodsOrder.detail.empty')" />
    </a-spin>
  </a-drawer>
</template>

<script>
import { getGoodsOrder } from '@/api/user/goodsOrder'

export default {
  name: 'GoodsOrderDetailDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    },
    /** 打开时用于标题展示，可与列表行一致 */
    orderNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail: null,
      jsonData:[]
    }
  },
  computed: {
    drawerTitle () {
      const no = this.orderNo || (this.detail && this.detail.orderNo) || this.orderId || '-'
      return this.$t('views.goodsOrder.drawer.detailTitleWithOrder', { orderNo: no })
    },
    /** 订单类型 1 = 首款订单 */
    isFirstPaymentOrderType () {
      return this.detail != null && Number(this.detail.orderType) === 1
    },
    /** 订单状态 9 = 已发货，10 = 已完成（均展示发货信息） */
    isOrderShipped () {
      if (this.detail == null) {
        return false
      }
      const s = Number(this.detail.orderStatus)
      return s === 9 || s === 10
    },
    /** 订单状态 6 = 生产中 */
    isOrderProducing () {
      return this.detail != null && Number(this.detail.orderStatus) === 6
    },
    /** 生产环节 1–8（与列表、后端 production_status 一致） */
    productionStatusStepIndex () {
      if (!this.detail) {
        return 1
      }
      const ps = this.detail.productionStatus
      if (ps === null || ps === undefined || ps === '') {
        return 1
      }
      const n = Number(ps)
      if (Number.isNaN(n) || n < 1) {
        return 1
      }
      if (n > 8) {
        return 8
      }
      return n
    },
    /** a-steps 的 current 为 0 起，当前环节为「进行中」，之前为「已完成」 */
    productionStepCurrent () {
      return this.productionStatusStepIndex - 1
    },
    /** remark 为 [{"money","totalNum"},...] 的 JSON 时解析为阶梯价 */
    priceTierList () {
      if (!this.detail) {
        return []
      }
      const r = this.detail.remark
      if (r == null || r === '') {
        return []
      }
      let arr
      try {
        arr = typeof r === 'string' ? JSON.parse(r.trim()) : r
      } catch (e) {
        return []
      }
      if (!Array.isArray(arr) || arr.length === 0) {
        return []
      }
      const rows = arr.filter(
        item => item != null && typeof item === 'object' && ('money' in item || 'totalNum' in item)
      )
      if (rows.length === 0) {
        return []
      }
      return [...rows].sort((a, b) => Number(a.totalNum) - Number(b.totalNum))
    },
    /** 非阶梯 JSON 时的备注原文展示 */
    plainRemarkDisplay () {
      if (!this.detail || this.priceTierList.length > 0) {
        return ''
      }
      const r = this.detail.remark
      if (r == null || r === '') {
        return ''
      }
      return typeof r === 'string' ? r : String(r)
    }
  },
  watch: {
    visible (v) {
      if (v && this.orderId != null && this.orderId !== '') {
        this.loadDetail()
      } else if (!v) {
        this.detail = null
      }
    },
    orderId () {
      if (this.visible && this.orderId != null && this.orderId !== '') {
        this.loadDetail()
      }
    }
  },
  methods: {
    hasCopyableText (v) {
      if (v === null || v === undefined) {
        return false
      }
      return String(v).trim() !== ''
    },
    copyField (value) {
      if (!this.hasCopyableText(value)) {
        this.$message.warning(this.$t('views.goodsOrder.detail.copyEmpty'))
        return
      }
      const text = String(value).trim()
      this.$copyText(text).then(() => {
        this.$message.success(this.$t('views.goodsOrder.detail.copyOk'))
      }).catch(() => {
        this.$message.error(this.$t('views.goodsOrder.detail.copyFail'))
      })
    },
    handleClose () {
      this.$emit('close')
    },
    cell (v) {
      if (v === null || v === undefined || v === '') {
        return '—'
      }
      return v
    },
    formatOrderTypeString (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const n = Number(value)
      const keyByNum = {
        0: 'views.goodsOrder.detail.payModeFull',
        1: 'views.goodsOrder.detail.payModeFirstFinal',
        2: 'views.goodsOrder.detail.payModeMonthly'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : String(value)
    },
    /** 产品明细行：支持中文冒号或英文冒号 */
    splitProductLine (line) {
      if (line == null) {
        return { label: '', value: '' }
      }
      const s = typeof line === 'string' ? line : String(line)
      let idx = s.indexOf('：')
      if (idx < 0) {
        idx = s.indexOf(':')
      }
      if (idx < 0) {
        return { label: s, value: '' }
      }
      return { label: s.slice(0, idx).trim(), value: s.slice(idx + 1).trim() }
    },
    formatOrderType (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const n = Number(value)
      const keyByNum = {
        0: 'views.goodsOrder.orderType.full',
        1: 'views.goodsOrder.orderType.first',
        2: 'views.goodsOrder.orderType.monthly'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : String(value)
    },
    formatProductionStage (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const n = Number(value)
      if (Number.isNaN(n) || n < 1 || n > 8) {
        return String(value)
      }
      return this.$t('views.goodsOrder.productionStage.' + n)
    },
    formatOrderStatus (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const n = Number(value)
      const keyByNum = {
        [-1]: 'views.goodsOrder.orderStatus.cancelled',
        0: 'views.goodsOrder.orderStatus.pending',
        1: 'views.goodsOrder.orderStatus.awaitPay',
        2: 'views.goodsOrder.orderStatus.paidAwaitAudit',
        3: 'views.goodsOrder.orderStatus.factoryRejected',
        4: 'views.goodsOrder.orderStatus.awaitDraft',
        5: 'views.goodsOrder.orderStatus.draftReceived',
        6: 'views.goodsOrder.orderStatus.producing',
        7: 'views.goodsOrder.orderStatus.awaitShip',
        8: 'views.goodsOrder.orderStatus.awaitFinalPayment',
        9: 'views.goodsOrder.orderStatus.shipped',
        10: 'views.goodsOrder.orderStatus.completed'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : String(value)
    },
    formatSubPayment (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const n = Number(value)
      const keyByNum = {
        0: 'views.goodsOrder.subPayment.pending',
        1: 'views.goodsOrder.subPayment.confirmed',
        2: 'views.goodsOrder.subPayment.rejected'
      }
      const key = keyByNum[n]
      return key ? this.$t(key) : String(value)
    },
    formatBool01 (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      return Number(value) === 1 ? this.$t('views.goodsOrder.bool.yes') : this.$t('views.goodsOrder.bool.no')
    },
    formatTierTotalNum (v) {
      if (v === null || v === undefined || v === '') {
        return '—'
      }
      const n = Number(v)
      return Number.isNaN(n) ? String(v) : String(n)
    },
    formatTierMoney (v) {
      if (v === null || v === undefined || v === '') {
        return '—'
      }
      const n = Number(v)
      if (Number.isNaN(n)) {
        return String(v)
      }
      const amount = n.toFixed(2)
      return this.$t('views.goodsOrder.detail.priceTierMoneyFmt', { amount })
    },
    loadDetail () {
      this.loading = true
      this.detail = null
      getGoodsOrder({ id: this.orderId })
        .then(res => {
          this.detail = res.data
          let jd = []
          try {
            const raw = res.data && res.data.jsonData
            if (raw != null && raw !== '') {
              jd = typeof raw === 'string' ? JSON.parse(raw) : raw
            }
            if (!Array.isArray(jd)) {
              jd = []
            }
          } catch (e) {
            jd = []
          }
          this.jsonData = jd
        })
        .catch(() => {
          this.$message.error(this.$t('views.goodsOrder.msg.loadDetailFail'))
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.goods-order-detail-copy-line {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
}
.goods-order-detail-copy-text {
  word-break: break-all;
}
.goods-order-detail-copy-btn {
  padding: 0 4px;
  height: auto;
  flex-shrink: 0;
}

.goods-order-production-steps-wrap {
  margin-top: 16px;
}
.goods-order-production-steps-scroll {
  overflow-x: auto;
  padding: 8px 0 4px;
  margin: 0 -4px;
}
.goods-order-production-steps-scroll .ant-steps {
  min-width: 720px;
}

.goods-order-detail-remark {
  white-space: pre-wrap;
  word-break: break-word;
}

.goods-order-price-tier-standalone {
  margin-top: 16px;
}

.goods-order-remark-plain {
  margin-top: 16px;
}

.goods-order-remark-plain-label {
  font-weight: 600;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.85);
}

.goods-order-price-tier-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.85);
}

.goods-order-price-tier-scroll {
  overflow-x: auto;
  max-width: 100%;
}

.goods-order-price-tier-table {
  border-collapse: collapse;
  min-width: 100%;
  table-layout: auto;
}

.goods-order-price-tier-table th,
.goods-order-price-tier-table td {
  border: 1px solid #f0f0f0;
  padding: 10px 14px;
  text-align: center;
  vertical-align: middle;
}

.goods-order-price-tier-row-head {
  background: #fafafa;
  font-weight: normal;
  white-space: nowrap;
}

.goods-order-price-tier-table td {
  background: #fff;
}
</style>
